export type AppEnv = 'local' | 'staging' | 'production' | 'unknown'

export function detectEnv(hostname: string): AppEnv {
  if (hostname === 'localhost' || hostname.endsWith('.localhost')) return 'local'
  if (hostname === 'app.rapallc.com') return 'production'
  // Add RAPA's staging hostname when known
  return 'unknown'
}

export const currentEnv = detectEnv(window.location.hostname)
